import { Component, OnInit, Injector, ElementRef, ViewChild, Input } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import { EventsComponent } from '../events/events.component';
import { find } from 'lodash';

@Component({
	selector: 'rates-dropdown',
	template: `
		<ng-select
			class="covmod-info-dropdown"
			[ngClass]="{ disabled: !isEditMode() || inputControl.disabled }"
			[items]="inputControl.options"
			[closeOnSelect]="true"
			[clearable]="false"
			(change)="updateDropdownAnswer($event)"
			placeholder="{{ setPlaceHolder() }}"
			[(ngModel)]="viewValue"
			[disabled]="!isEditMode() || inputControl.disabled"
			bindLabel="title"
		>
		</ng-select>
	`,
	styleUrls: ['./rates-dropdown.component.scss'],
})
export class RatesDropdownComponent extends EventsComponent implements OnInit {
	@Input() inputControl: any;
	@ViewChild(NgSelectComponent, { static: true })
	ngSelect: NgSelectComponent;
	viewValue: any;

	constructor(injector: Injector, private el: ElementRef) {
		super(injector);
	}

	ngOnInit() {
		this.value = this.inputControl.options.find((o) => o.selected == true).title;
	}

	ngAfterViewInit() {
		super.ngAfterViewInit();
	}

	updateDropdownAnswer(item) {
		this.value = item.title;

		var carrierInformation = this.storeService.getValue('CarrierInformation', 'page');

		const requestBody: request = {
			data: {
				carrierInformation: {
					carrierName: carrierInformation.name,
					lob: carrierInformation.lobname,
					packageType: 'Custom',
				},
				coverage: {
					name: this.inputControl.name,
					value: item.value,
				},
			},
			info: {
				action: this.inputControl.ajaxInfo.action,
				conditions: '',
				elementSrc: '',
				stage: '',
				notRenderPage: true,
			},
		};

		this.actionService.invokeAction(requestBody);

		return find(this.inputControl.options, { value: this.value });
	}

	setPlaceHolder() {
		this.viewValue = this.value.title;

		return this.value;
	}

	isEditMode() {
		return this.carrierInformationService.isEditMode;
	}

	isRecalculating() {
		return this.carrierInformationService.isRecalculating;
	}
}
